import React from "react";
import './Loginpg.css';
import { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";

import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


export default function Loginpg() {
    
  const navigate = useNavigate();

  const [uname, setuname] = React.useState("");
  const [pass, setpass] = React.useState("");

  function logindetails(){

    if(uname == "admin" && pass == "trendingdecor@123"){
        let path = '/adminestimate'; 
      
        
        navigate(path);
    }else{
        alert("Enter Valid Details");
    }

  }



  return (
    <div className="bodyl">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-2"></div>
        <div class="col-lg-6 col-md-8 login-box">
          <div class="col-lg-12 login-key">
            <i class="fa fa-key" aria-hidden="true"></i>
          </div>
          <div class="col-lg-12 login-title">ADMIN PANEL</div>

          <div class="col-lg-12 login-form">
            <div class="col-lg-12 login-form">
              <form>
                <div class="form-group">
                  <label class="form-control-label">USERNAME</label>
                  <TextField onChange={(e) => setuname(e.target.value)} className="iplg" type="text" />
                </div>
                <div class="form-group">
                  <label class="form-control-label">PASSWORD</label>
                  <TextField onChange={(e) => setpass(e.target.value)} className="iplg" type="password"  />
                </div>

                <div class="col-lg-12 loginbttm">
                  <div class="col-lg-6 login-btm login-text"></div>
                  <div class="col-lg-6 login-btm login-button">
                    <button onClick={logindetails} type="submit" class="btn btn-outline-primary">
                      LOGIN
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          {/* <div class="col-lg-3 col-md-2"></div> */}
        </div>
      </div>
    </div>
    <br/>
    <br/>
    <br/>
    <br/>
    </div>
  );
}

